/* @flow */
import React from 'react';
// $FlowIgnore
import { connect } from 'react-redux';

import { setModal } from 'ducks/modal';
import { DynamicEntityDownloadContainer } from 'containers/DownloadContainers';
import { DetailsSummaryContainer } from 'containers/DetailsSummaryContainer';
import { HierarchyLinksContainer } from 'containers/HierarchyContainer';

import { Row } from 'components/UIKit/Flex';
import Section from 'components/UIKit/Details/Content/Section';
import { Spinner } from 'components/UIKit/Spinner';
import { HelpIcon, TrashIcon } from 'components/icons';
import { Tooltip } from 'components/UIKit/Tooltip';
import HierarchyTooltip from 'components/Tooltips/HierarchyTooltip';
import DangerButton from 'components/UIKit/Button/DangerButton';
import DeleteEntity from 'components/DeleteEntity';
import ExternalLink from 'components/Links/ExternalLink';
import DetailsPanel from '../DetailsPanel';
import TransactionList from '../TransactionList';
import DynamicEntityDetailsNavigation from '../DynamicEntityDetails/DynamicEntityDetailsNavigation';

function AnnotationDetails({
  children, style, links, defs, dispatch, beingDeleted,
}: Object): React.Element {
  let entity = (children || {}).item || {};
  let headerId = entity.submitter_id;

  if (links?.links?.length) entity._links = links.links;

  let processing = beingDeleted.some(x => x.ids.includes(entity.id));

  return (
    <DetailsPanel
      style={style}
      headerId={headerId}
      details={children}
      defs={defs}
      NavigationComponent={DynamicEntityDetailsNavigation}
    >
      <Section id="actions" header="actions">
        <Row style={{ flexWrap: 'wrap' }}>
          <DynamicEntityDownloadContainer customDataTestID={`button-${entity.type}`} >
            {entity.type}
          </DynamicEntityDownloadContainer>
          <DangerButton
            customDataTestID="button-delete"
            PrefixComponent={
              processing
                ? <Spinner style={{ width: '15px', height: '15px', marginRight: '0.5rem' }} />
                : <TrashIcon style={{ marginRight: '0.2rem' }} />
            }
            disabled={entity.state === 'submitted' || processing}
            onClick={() => dispatch(setModal({
              Component: () => <DeleteEntity entity={entity} />,
            }))}
          >
            {processing ? 'Processing..' : 'Delete'}
          </DangerButton>
        </Row>
      </Section>

      <Section customDataTestID="table-details" id="details">
        <DetailsSummaryContainer entity={entity} entityType={entity.type}/>
      </Section>

      <Section
        customDataTestID="table-hierarchy" 
        id="hierarchy"
        header="hierarchy"
        icon={
          <Tooltip Component={<HierarchyTooltip />}>
            <ExternalLink
              arias={{ 'aria-label': 'Link to documentation on Hierarchy' }}
              href="https://docs.gdc.cancer.gov/Data_Submission_Portal/Users_Guide/Data_Submission_Process/#hierarchy"
              >
              <HelpIcon />
            </ExternalLink>
          </Tooltip>
        }
      >
        { links.isFetching ? <Spinner /> :
        <HierarchyLinksContainer entity={entity} defs={defs} />
        }
      </Section>

      <Section customDataTestID="table-transactions" id="transactions" header="transactions" count={(entity._transaction_logs || []).length}>
       { (entity._transaction_logs || []).length ? (
         <TransactionList>{entity._transaction_logs}</TransactionList>
       ) : 'No transactions'}
      </Section>

      <Section
      // this helps the navigation items reach the bottom properly and be clickable
      />
    </DetailsPanel>
  );
}

export default connect(
  state => ({
    links: state.links,
    beingDeleted: state.details.beingDeleted,
    defs: state.entityDefinitions.defs,
  })
)(AnnotationDetails);
